<template>
    <DefaultLayout>
        <div class="container">
            <button class="btn">  <RouterLink :to="{ name: 'agenda'} " style="color: white; text-decoration: none; font-weight: bold;">Volver</RouterLink></button>
            <br />
            <h1  :style="{'color' : main.SECONDARY_COLOR }">{{quote.title}}</h1>
            <br />
            <h3 :style="{'color' : main.SECONDARY_COLOR }">Fecha y hora :</h3>
            <br>
            <p v-if="quote.date">{{ quote.date.slice(0,16) }}</p>
            <br>
            <h3  :style="{'color' : main.SECONDARY_COLOR }">Detalles :</h3>
            <br>
            <p class="notification-content">{{ quote.description }}</p>
             <br>
            
        </div>
    </DefaultLayout>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import AgendaService from '@/services/AgendaService'
import { useRoute } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import main from '@/data/main.js'

const route =  useRoute()
const service = new AgendaService()
const quote:any = ref([])
const loading = ref(false)

onMounted(async()=>{
    loading.value = true
    quote.value = await service.GetQuoteDetails(route.params.id)
    loading.value = false
})

</script>

<style lang="scss" scoped>
button {
    padding: 10px;
    border: 0;
    outline: 0;
    background-color: $secondary-color;
    color: white;
    border-radius: 5px;
    margin: 2px;
    cursor: pointer;
}
.btn{
    width: 120px;
    color: white;
    background-color: $third-color;
}
.btn:hover {
    background-color: $secondary-color;
}
ul {
    margin-top: 20px;
}
li {
    width: 70vw;
    background-color: $primary-color;
    padding: 20px;
    border-radius: 10px;
}
.notification-content {
    white-space: pre-wrap; /* Esto respeta los saltos de línea */
}
</style>